import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import InputMask from 'react-input-mask';


export class EditContact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
            isdirtycontactfirstname: false,
            isdirtycontactcontactlastname: false,
            isdirtycontactcellphone: false

        };

        this.toggleModal = this.toggleModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount() {

        this.setState({
            contactfirstname: this.props.memberDetail != null ? this.props.memberDetail.FirstName : '',
            contactlastname: this.props.memberDetail != null ? this.props.memberDetail.LastName : ''
        })

    }


    handleChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            ['isdirty' + name]: true
        });

    }


    toggleModal() {
        this.setState({
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
            isdirtycontactfirstname: false,
            isdirtycontactlastname: false,
            isdirtycontactcellphone: false
        });
        this.props.toggle();
    }


    handleSubmit(e) {
        e.preventDefault();
        this.props.toggle();

        var interactionContactIDs = this.props.thread.InteractionContactIDs;

        var contactfirstname = !this.state.isdirtycontactfirstname ? this.props.memberDetail != null ? this.props.memberDetail.FirstName : '' : this.state.contactfirstname;
        var contactlastname = !this.state.isdirtycontactlastname ? this.props.memberDetail != null ? this.props.memberDetail.LastName : '' : this.state.contactlastname;
        var contactcellphone = !this.state.isdirtycontactcellphone ? this.props.memberDetail != null ? this.props.memberDetail.CellPhone : '' : this.state.contactcellphone;
        var interactionContactType = this.props.memberDetail != null ? this.props.memberDetail.InteractionContactType : 0;
        contactcellphone = contactcellphone.toString();

        this.setState({
            contactfirstname: '',
            contactlastname: '',
            contactcellphone: '',
            isdirtycontactfirstname: false,
            isdirtycontactlastname: false,
            isdirtycontactcellphone: false
        });
        //automatically chose the first member id in the list.

        this.props.editContact(interactionContactIDs[0], interactionContactType, contactfirstname, contactlastname, contactcellphone);
    }


    render() {


        var contactfirstname = !this.state.isdirtycontactfirstname ? this.props.memberDetail != null ? this.props.memberDetail.FirstName : '' : this.state.contactfirstname;
        var contactlastname = !this.state.isdirtycontactlastname ? this.props.memberDetail != null ? this.props.memberDetail.LastName : '' : this.state.contactlastname;
        var contactcellphone = !this.state.isdirtycontactcellphone ? this.props.memberDetail != null ? this.props.memberDetail.CellPhone : '' : this.state.contactcellphone;
       
        return (

            <Modal isOpen={this.props.isOpen} toggle={this.toggleModal} className={this.props.className}>
                <ModalHeader toggle={this.toggleModal}>Edit Contact</ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label className="form-label semibold" >First Name</label>
                        <input type="text" className="form-control" name="contactfirstname" placeholder="First Name" value={contactfirstname} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Last Name</label>
                        <input type="text" className="form-control" name="contactlastname" placeholder="Last Name" value={contactlastname} onChange={this.handleChange} />
                    </div>
                    <div className="form-group">
                        <label className="form-label semibold" >Cell Phone</label>
                        <InputMask className="form-control" name="contactcellphone" mask="(999) 999-9999" value={contactcellphone} maskChar=" " onChange={this.handleChange} />
                    </div>


                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" className="btn btn-rounded" onClick={this.toggleModal}>Close</Button>
                    <Button color="primary" className="btn btn-rounded" onClick={this.handleSubmit}>Save</Button>{' '}
                </ModalFooter>
            </Modal>

        );
    }

}